import Index from '../pages/posts/Index.vue';

export default {
    routes: [{
        path: '/posts',
        component: Index,
        name: 'posts',
        meta: {
            name: 'Posts'
        }
    }]
};